<template>
    <app-wrapper>
        <app-header :loan="loan"
                    medium-max-width="max-w-1000"
                    medium-max-width-inner="max-w-500">
            <template #navigation>
                <div class="w-full max-w-500 mx-auto flex items-center justify-between mb-6">
                    <h5 class="font-zen-dots text-white">
                        <AppLogo />
                    </h5>
                    <a href="#back" @click.prevent="goBack" class="no-underline border border-white rounded text-white text-center font-semibold py-1.5 px-2">Cancel</a>
                </div>
            </template>
        </app-header>
        <app-body :collapsed="true" medium-max-width="max-w-500" footer>

            <template #title>
                Connect your bank account
            </template>

            <template #text>
                Your account has been flagged as closed or without income. To keep your account from defaulting, connect to a new bank account.
            </template>

            <template #main>
                <ConnectBankAccounts
                :loan="loan"
                :user="user"
                :mxWidgetUrl="mxWidgetUrl"
                :plaidLinkToken="plaidLinkToken"
                />

            </template>
        </app-body>
    </app-wrapper>
</template>

<script>
import AppLogo from './../components/AppLogo';
import ConnectBankAccounts from "./../components/ConnectBankAccounts.vue";

export default {
    mixins: [
        require('../mixins/InteractsWithGtag').default
    ],
    components: {
        AppLogo, ConnectBankAccounts
    },
    props: {
        csrf: {},
        user: {},
        loan: {},
        mxWidgetUrl: {},
        plaidLinkToken: {}
    },

    data() {
        return {
            gTagPageName: 'change-bank',
            mx: null,
            plaid: null,
            institution_id: null,
            institution_code: null,
            loading: false,
            done: false,
            plaidLoading: false,
            showManual: false,
        }
    },

    created() {
        if (this.loan.banking_vendor?.name === 'mx') {
            this.mx = new window.MXConnect({
                id: 'mx-connect-widget',
                iframeTitle: 'Connect',
                targetOrigin: '*',
                onEvent: this.onEvent,
                config: { ui_message_version: 4 },
            });
        }
    },

    mounted() {
        if (this.loan.banking_vendor?.name === 'mx') {
            this.mx.load(this.mxWidgetUrl);
        } else if (this.loan.banking_vendor?.name === 'plaid') {
            setTimeout(() => {
                this.plaid = window.Plaid.create({
                    token: this.plaidLinkToken,
                    onSuccess: (public_token, metadata) => {
                        this.plaidLoading = true;

                        this.$http.post(`/account/change-bank/plaid/${this.loan.id}`, {
                            public_token,
                            institution: metadata.institution,
                        }).then(() => {
                            this.plaidLoading = false;

                            this.continue();
                        }).catch(error => {
                            this.plaidLoading = false;
                        })
                    },
                    onEvent: (event, metadata) => {
                        if (event == 'ERROR') {
                            window.Bugsnag.notify('fail ChangeBank  : ' + JSON.stringify({
                                error: metadata.error_code + ' (' + metadata.error_message + ')',
                                loan_id: this.loan?.id,
                                user_id: this.user?.id,
                            }));
                        }

                        this.$http?.post('/api/plaid/link-events', {
                            event_name: event,
                            loan_id: this.loan?.id ?? null,
                            institution_name: metadata.institution_name ?? metadata.institution?.name ?? null,
                            error_type: metadata.error_type ?? null,
                            error_code: metadata.error_code ?? null,
                            error_message: metadata.error_message ?? null,
                            link_session_id: metadata.link_session_id ?? null,
                            request_id: metadata.request_id ?? null,
                            exit_status: metadata.exit_status ?? null,
                            metadata: metadata,
                            event_time: new Date().toISOString(),
                        }).catch(() => {});
                    },
                    onExit: () => {
                      this.plaidLoading = false;
                    },
                });

                this.plaid.open();
            }, 150);
        }
    },

    methods: {
        goBack() {
            window.history.go(-1);
        },

        /**
         * @param type
         * @param payload
         */
        onEvent(type, payload) {
            this.loading = true;

            switch (type) {
                case 'mx/connect/selectedInstitution':
                    this.institution_id = payload.guid;
                    this.institution_code = payload.code;
                    break;
                case 'mx/connect/memberConnected':
                    return this.mxConnected(payload);
                case 'mx/connect/connected/primaryAction':
                    return this.continue();
            }
        },

        /**
         * TriggeredBankChange after they successfully connect their bank to MX.
         *
         * @param payload
         * @return {void}
         */
        mxConnected(payload) {
            this.$http.post(`/account/change-bank/mx/${this.loan.id}`, {
                ...payload,
                ...{
                    institution_guid: this.institution_id,
                    institution_code: this.institution_code,
                }
            }).then(() => this.done = true);
        },

        /**
         * TriggeredBankChange after they've connected, and click "Continue."
         *
         * Keeps change-bank mode on the billing page: connecting a bank is only
         * half the flow, and the picker has to say so, offer only the bank that
         * was just connected, and not read like an ordinary billing edit.
         *
         * @return {void}
         */
        continue() {
            this.loading = false;

            window.location.href = `/account/account?edit-billing=1&change-bank=1`;
        },
    }
}
</script>
